import React from 'react';
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import PersonIcon from '@mui/icons-material/Person';
import { type RestModalPerson } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';

import './avatar.scss';

type Props = {
  person: RestModalPerson | undefined;
  vertical?: boolean;
  alignRight?: boolean;
  includeArrow?: boolean;
  arrowStyles?: SerializedStyles;
  arrowColor?: React.CSSProperties['color'];
};

const standardAvatarStyles = {
  width: '105px',
  height: '105px',
  borderRadius: '50%',
  boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.15)',
};

const PersonAvatar = () => (
  <PersonIcon
    style={{
      padding: '15px',
      backgroundColor: '#ccc',
      fill: '#fff',
      ...standardAvatarStyles,
    }}
    className="bbk-avatar-image"
  />
);

const Name = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
`;

const Position = styled.div`
  font-size: 0.9rem;
  padding-right: 5px;
`;

const Organization = styled.span`
  font-weight: bold;
`;

export const Avatar: React.FC<Props> = (props) => {
  const {
    person: { title, organization, preposition, avatar, name } = {},
    vertical,
    alignRight,
    includeArrow,
    arrowStyles = {},
    arrowColor = '#f3f3f3',
    ...other
  } = props;

  const ImageStyles = {
    ...standardAvatarStyles,
  };

  return (
    <div
      css={css`
        position: relative;
      `}
      className={cs('bbk-avatar', 'display-grid', {
        vertical: vertical,
        horizontal: !vertical,
      })}
      {...other}
    >
      {avatar ? (
        <img
          src={avatar}
          alt=""
          css={ImageStyles}
          className="bbk-avatar-image"
        />
      ) : (
        <PersonAvatar />
      )}
      <div>
        <Name>{name}</Name>
        <Position>
          {title} {preposition} <Organization>{organization}</Organization>
        </Position>
      </div>
      {includeArrow && (
        <div
          className="arrow"
          css={[
            css`
              position: absolute;
              width: 0;
              height: 0;
              right: 0;
              border-top: 10px solid transparent;
              border-bottom: 10px solid transparent;
              border-right: 10px solid ${arrowColor};
              top: 22px;
            `,
            arrowStyles,
          ]}
        ></div>
      )}
    </div>
  );
};
